import { FunctionalComponent } from 'preact'
import type { CompanyTrackingViewDto } from '@/types/tracking'
import type { ApiResponse } from '@/api/client'
import { ApprovedDomainsPanel } from './ApprovedDomainsPanel'

interface ApprovedDomainsCardProps {
  tracking: CompanyTrackingViewDto | null
  isLoading: boolean
  error: string | null
  saveApprovedDomains: (domains: string[]) => Promise<ApiResponse<CompanyTrackingViewDto> | null>
}

/**
 * Standalone settings card wrapping the approved-domains allowlist (ORB-458). Split out of the
 * Visitor Tracking panel so it can sit under Company Information; shares the lifted tracking state
 * (see CompanyHeader) rather than fetching its own, so a save here can't clobber a toggle there.
 */
export const ApprovedDomainsCard: FunctionalComponent<ApprovedDomainsCardProps> = ({
  tracking,
  isLoading,
  error,
  saveApprovedDomains,
}) => {
  return (
    <div className="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 p-6">
      {isLoading && (
        <div className="space-y-3">
          <div className="h-4 w-32 rounded bg-slate-200 dark:bg-slate-600 animate-pulse" />
          <div className="h-20 rounded bg-slate-200 dark:bg-slate-600 animate-pulse" />
        </div>
      )}

      {!isLoading && error && (
        <div className="text-sm text-red-600 dark:text-red-400">{error}</div>
      )}

      {!isLoading && !error && tracking && (
        <ApprovedDomainsPanel tracking={tracking} onSave={saveApprovedDomains} />
      )}
    </div>
  )
}
